module.exports = __webpack_public_path__ + "static/media/leaf.aa1831aa.svg";